import { Box, Button } from "@mui/material";
import GlobalButton from "../CustomButton";

const CustomDrawerFooter = ({ activeStep, onNext, btnTitle }) => {
  return (
    <Box
      sx={{
        position: "static",
        bottom: 0,
        width: "100%",
        borderTop: 1,
        borderColor: "divider",
        p: 1,
        display: "flex",
        gap: 2,
        justifyContent: "center",
      }}
    >
      <Button
        variant="contained"
        onClick={onNext}
        sx={{
          height: 40,
          width: activeStep === 0 ? "100%" : "100%",
        }}
      >
        {btnTitle}
      </Button>
    </Box>
  );
};

export default CustomDrawerFooter;
